import { styled } from '@mui/material'
import { colorPalette } from '../../../../style/colorPalette'

export const ThreadListContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
})

export const EmptyMessage = styled('div')({
  textAlign: 'center',
  color: colorPalette.monotone[4],
  fontSize: '14px',
  padding: '32px 16px',
})

export const LoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px 16px',
})
